import React, { useEffect, useState, useRef } from "react";
import API from "../../../services/api";
import { Toast } from "../../../shared/Toast";
import { BrandsTypes } from "../../../utils/constants";
import Select from "react-select";
import { CSVLink } from "react-csv";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { SlOption, SlSelect} from "@shoelace-style/shoelace/dist/react";
import SalesPerformanceTable from "./SalesPerformanceTable";
function NewBusinessDevelopment() {
    const now = new Date();

  // End of the current month
  const endOfCurrentMonth = new Date(now.getFullYear(), now.getMonth() + 1, 0); 
  endOfCurrentMonth.setHours(23, 59, 59, 999);
  
  // Start of the month 12 months ago
  const startOf12MonthsAgo = new Date(now.getFullYear(), now.getMonth() - 11, 1);
  startOf12MonthsAgo.setHours(0, 0, 0, 0);

  const [MonthRange, setMonthRange] = useState([startOf12MonthsAgo, endOfCurrentMonth]);
  const [brandtype,setbrandtype] = useState(2);
  const [salesList, setsalesList] = useState([]);
  const [salesId, setsalesId] = useState([]);
  const [data, setData] = useState([]);   
  const [isLoading, setIsLoading] = useState(false);
  const [csvData, setCsvData] = useState([]);
  const [business,setBusiness] = useState('0')
  

  const csvLinkRef = useRef(null);


  const handleFetch = async () => {
    try {
      const result = await API({
        url: "/phionex_reports/new_business_development",
        method: "POST",
        data: { 
          selectedmonth: MonthRange,
          salesId:salesId.length > 0 ? salesId : salesList.map(sales => sales.value),
          business
        },
      });
      if (result.status === "SUCCESS") {
        return result.data || [];
      } else {
        Toast("error", result?.message || "Failed To Fetch Data");
        return [];
      }
    } catch (error) {
      Toast("error", "An error occurred");
      return [];
    }
  };
  const getSales = async () => {
    try {
      let res = await API({
        url:"/planning/getSales",
        method:'POST',
        responseType:'json',
        data:{
          type:brandtype
        }
      })
      if(res.code === 200){
        const formatted = res.data.map((item) => ({
          value: item.sales_person_id,
          label: item.name
        }));
        setsalesList(formatted)
      }
    } catch (error) {
      console.error(error);
    }
  }
  
  useEffect(()=>{
    if(brandtype)
    {
      getSales();
    }
    else
    {
      setsalesId([]);
      setsalesList([]);
    }
  },[brandtype])
  // Fetch data whenever year or selectedLocation changes
  useEffect(() => {
    const fetchData = async () => {
      setIsLoading(true);
      let result = []
      if(salesList.length && MonthRange[0] != null && MonthRange[1] != null)
        result = await handleFetch()
      setData(result);
      setIsLoading(false);
    };
    fetchData();
  }, [MonthRange,brandtype,salesId,salesList.length,business]);

  // Compute Grand Total dynamically
  const prepareCSVData = () => {
    if (!data || data.length === 0) return [];
  
    // Map your data into CSV rows
    const csvRows = data.map((row) => ({
      Location: row.Location.replace(/"/g, ""),
      "Total Brands": Number(row.total_brands_count),
      "Eenadu Active clients": Number(row.eenadu_clients_count),
      "Way2news Clients": Number(row.w2n_clients_count),
      "Insertions": Number(row.insertions),
    }));
  
    // Add Grand Total row
    const grandTotal = data.reduce(
      (acc, row) => {
        acc["Total Brands"] += Number(row.total_brands_count);
        acc["Eenadu Active clients"] += Number(row.eenadu_clients_count);
        acc["Way2news Clients"] += Number(row.w2n_clients_count);
        acc["Insertions"] += Number(row.insertions);
        return acc;
      },
      { "Total Brands": 0, "Eenadu Active clients": 0, "Way2news Clients": 0, "Insertions": 0 }
    );
  
    csvRows.push({
      Location: "Grand Total",
      ...grandTotal,
    });
  
    return csvRows;
  };
  
  const handlePrepareCSV = () => {
    const preparedData = prepareCSVData();
    setCsvData(preparedData);
  };
  useEffect(() => {
    if (csvData.length > 0) {
      csvLinkRef.current.link.click();
      setCsvData([]); // reset to prevent repeated downloads
    }
  }, [csvData]);
  return (
    <>
        <aside className='flex gap-3 justify-end items-center'>
        <div className="flex items-center gap-3">
              <span className="font-semibold whitespace-nowrap">Brand Type:</span>
              <Select
                className="min-w-[200px]"
                placeholder="Select Brand Type"
                name="queryAdType"
                size="medium"
                value={BrandsTypes.find((option) => option.value === brandtype) || null}
                onChange={(selected) => setbrandtype(selected ? selected.value : null)}
                options={BrandsTypes}
                isClearable
              />
            </div>

            {/* Sales Person */}
            <div className="flex items-center gap-3">
              <span className="font-semibold whitespace-nowrap">Sales Person:</span>
              <Select
                className="min-w-[220px]"
                placeholder="Select Sales Person"
                options={salesList}
                value={salesList.filter((opt) => salesId?.includes(opt.value))}
                onChange={(selected) => {
                  const values = selected ? selected.map((item) => item.value) : [];
                  setsalesId(values);
                }}
                isMulti
                isClearable
              />
            </div>
            <div className="flex flex-wrap items-center gap-6">
            {/* Month Picker */}
            <div className="flex items-center gap-3">
              <span className="font-semibold whitespace-nowrap">Select Month:</span>
              <DatePicker
                selected={MonthRange[0]}
                onChange={(update) => setMonthRange(update)}
                startDate={MonthRange[0]}
                endDate={MonthRange[1]}
                dateFormat="MM/yyyy"
                showMonthYearPicker
                selectsRange
                className="border border-gray-300 rounded-md px-3 py-2 text-sm focus:ring-2 focus:ring-blue-500"
                maxDate={new Date()}
              />
            </div>
            <div className="mb-3">
                  <SlSelect size="small" onSlChange={(e)=>{setBusiness(e.target.value)}} value={business} label="Business">
                      <SlOption value={'0'}>Old</SlOption>
                      <SlOption value={'1'}>New</SlOption>
                      <SlOption value={'2'}>Re-engaged</SlOption>
                  </SlSelect>
            </div>
            <CSVLink
              data={csvData}
              filename={`phionex_reports_sheet3.csv`}
              className="hidden"
              ref={csvLinkRef}
            />
            {data.length > 0 && !isLoading && (
              <button
                onClick={handlePrepareCSV}
                className="px-4 py-2 bg-blue-600 text-white rounded hover:bg-blue-700"
              >
                Download Report
              </button>
            )}
          </div>
        </aside>
        <div className="mt-3">
           <SalesPerformanceTable data={data} salesList={salesList} MonthRange={MonthRange} isLoading={isLoading} business={business}/>
        </div>
    </>
  )
}

export default NewBusinessDevelopment